import { NaniumObject, RequestType } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { LifeHack } from "../../entities/lifeHack.entity";

export class LifeHackQueryRequestBody extends NaniumObject<LifeHackQueryRequestBody> {
}

@RequestType({
	responseType: LifeHack,
	genericTypes: { TRequestBody: LifeHackQueryRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class LifeHackQueryRequest extends ServiceRequestBase<LifeHackQueryRequestBody, LifeHack[]> {
	static serviceName: string = 'NaniumDemo:lifeHack/query';
}
